import useGlobalState from 'crm/GlobalStateContext';
import { PERMISSION, ROLE } from 'crm/helpers/Permissions';

export const ALLOWED_ROLES = [
    ROLE.SUPER_ADMIN,
    ROLE.WHITELABEL_SUPER_ADMIN,
    ROLE.MASTER_AFFILIATE_AGENT,
    ROLE.AFFILIATE_OWNER,
];

function useAffiliateRevenueAuth() {
    const { loggedAdmin } = useGlobalState();
    const hasAccess = loggedAdmin.hasPermission(PERMISSION.UPDATE_AFFILIATE) && loggedAdmin.hasRole(...ALLOWED_ROLES);

    return hasAccess;
}

export default useAffiliateRevenueAuth;
